var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_1_08568"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_1_08568)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1C5.9257,1,1,5.92325,1,11.9975C1,18.0718,5.9257,22.9975,12,22.9975C18.0743,22.9975,23,18.0718,23,11.9975C23,5.92325,18.0743,1,12,1ZM16.950200000000002,12.7068L12.7068,16.9478C12.3166,17.338,11.6834,17.338,11.2932,16.9478L7.04975,12.7068C6.65953,12.3166,6.65953,11.6834,7.04975,11.2932L11.2932,7.04975C11.6834,6.65953,12.3166,6.65953,12.7068,7.04975L16.950200000000002,11.2932C17.3405,11.6834,17.3405,12.3141,16.950200000000002,12.7068Z",
    fill: "#A8CBB4",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityIcon);
export default __webpack_public_path__ + "static/media/mobilityIcon.b43aa57ea033e18052664250d4777590.svg";
export { ForwardRef as ReactComponent };